import { useEditorStore } from '../store/editor.store'
import { BlockRenderer } from '../components/blocks/renderers'

export function PreviewPage() {
  const { page } = useEditorStore()

  return (
    <div style={{ minHeight: '100vh', background: '#fff', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif' }}>
      {/* Preview toolbar */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '40px',
        background: '#1a1a1a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        zIndex: 9999,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '12px', color: '#888' }}>Предпросмотр</span>
          <span style={{ fontSize: '12px', color: '#555', borderLeft: '1px solid #333', paddingLeft: '12px' }}>
            {page.title}
          </span>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <DeviceButtons />
          <button
            onClick={() => window.close()}
            style={{ padding: '4px 14px', background: '#5b6af0', color: '#fff', border: 'none', borderRadius: '5px', fontSize: '12px', fontWeight: 500, cursor: 'pointer' }}
          >
            ✕ Закрыть
          </button>
        </div>
      </div>

      {/* Page content */}
      <div id="preview-content" style={{ paddingTop: '40px' }}>
        {page.sections.length === 0 ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 40px)', flexDirection: 'column', gap: '12px', color: '#888' }}>
            <span style={{ fontSize: '48px' }}>✦</span>
            <p style={{ fontSize: '16px' }}>Страница пустая — добавьте блоки в редакторе</p>
          </div>
        ) : (
          page.sections.filter(s => s.blocks.length > 0).map((section) => {
            const isFullPageBlock = section.blocks.some(b => b.type === 'swiss-page')
            return (
              <div
                key={section.id}
                style={{
                  background: !isFullPageBlock && section.background !== 'transparent' ? section.background : undefined,
                  backgroundSize: section.backgroundSize,
                  backgroundPosition: section.backgroundPosition,
                  backgroundRepeat: 'no-repeat',
                  paddingTop: isFullPageBlock ? 0 : section.paddingTop,
                  paddingBottom: isFullPageBlock ? 0 : section.paddingBottom,
                }}
              >
                {section.blocks.map((block) => (
                  <BlockRenderer key={block.id} block={block} selected={false} />
                ))}
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

function DeviceButtons() {
  const sizes = [
    { label: '🖥 Desktop', width: '100%' },
    { label: '📱 Tablet', width: '768px' },
    { label: '📲 Mobile', width: '390px' },
  ]
  const setWidth = (w: string) => {
    const content = document.getElementById('preview-content')
    if (content) content.style.maxWidth = w
  }
  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      {sizes.map((s) => (
        <button
          key={s.label}
          onClick={() => setWidth(s.width)}
          style={{ padding: '3px 8px', background: 'transparent', color: '#888', border: '1px solid #333', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }}
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
